import { gql } from '@apollo/client';

export const CREATE_USER_SELF_ONBOARDING = gql`
    mutation CreateUserSelfOnboarding($accountInput: AccountInput!, $createUser: Boolean) {
        createUserSelfOnboarding(accountInput: $accountInput, createUser: $createUser)
    }
`;
